import axios from "axios";
import ButtonTheme from "css/themes/Buttons.css";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";
import { connect } from "react-redux";
import { Button } from "react-toolbox/lib/button";
import { Card } from "react-toolbox/lib/card";
import COLOURS from "util/colours";
import { H3, P } from "visual-components/util/texts";

const styles = {
  winnerCard: {
    padding: "12px 12px 28px 28px",
    marginBottom: 20,
    width: "100%",
    border: `1px solid ${COLOURS.skyBase}`,
    boxShadow: "none",
  },
  winnerHeading: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  winnerCopy: {
    marginBottom: 20,
  },
  winnerInfo: {
    display: "flex",
  },
  winnerInfoStat: {
    marginRight: 60,
  },
};
const mapStateToProps = ({ currentCampaign, classes }) => ({
  currentCampaign,
  classes,
});
class SoloWinnerCard extends React.Component {
  state = {
    winnerInfo: null,
  };
  static propTypes = {
    currentCampaign: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { currentCampaign } = this.props;
    if (currentCampaign?.winner_id) {
      this.fetchWinner(currentCampaign);
    }
  }

  fetchWinner = async (currentCampaign) => {
    try {
      await axios
        .get(`campaign-winner-details/${currentCampaign?.id}`, {
          headers: {
            brand: currentCampaign?.hostBrandId,
          },
        })
        .then((res) => {
          const data = res.data;
          this.setState({
            winnerInfo: {
              name: data.Name ? data.Name : "",
              email: data.Email,
              zipcode: data.Zipcode,
              sourceBrand: data.fromBrand,
            },
          });
        });
    } catch (error) {
      console.error("Failed to fetch winner:", error);
    }
  };

  renderWinnerInfo = (winnerInfo) => {
    const { chooseWinner, classes } = this.props;
    return winnerInfo ? (
      <div className={classes.winnerInfo}>
        <div className={classes.winnerInfoStat}>
          <P>
            <i>Name</i>
          </P>
          <H3>
            <small>{winnerInfo.name}</small>
          </H3>
        </div>
        <div className={classes.winnerInfoStat}>
          <P>
            <i>Email</i>
          </P>
          <H3>
            <small>{winnerInfo.email}</small>
          </H3>
        </div>
        <div className={classes.winnerInfoStat}>
          <P>
            <i>Zipcode</i>
          </P>
          <H3>
            <small>{winnerInfo.zipcode}</small>
          </H3>
        </div>
      </div>
    ) : (
      <div>
        <Button
          onClick={chooseWinner}
          label="Pick Winner"
          className={ButtonTheme.blueButton}
          theme={ButtonTheme}
          primary
          raised
        />
      </div>
    );
  };

  render() {
    const { chooseWinner, classes } = this.props;
    const { winnerInfo } = this.state;
    console.log("hell11", winnerInfo);
    return (
      <Card className={classes.winnerCard}>
        <div className={classes.winnerHeading}>
          <H3>
            <small>Winner Info</small>
          </H3>
          <Button
            onClick={chooseWinner}
            label="Pick Another Winner"
            className={ButtonTheme.whiteButtonAzureText}
            theme={ButtonTheme}
            raised
          />
        </div>
        <div className={classes.winnerCopy}>
          <P>As the host, you’ll need to notify the winner of their prize.</P>
        </div>
        {this.renderWinnerInfo(winnerInfo)}
      </Card>
    );
  }
}

export default connect(mapStateToProps)(injectSheet(styles)(SoloWinnerCard));
